export const layoutConstants = {
  SEO: {
    title: 'Welcome',
    description: 'Welcome',
    image: '/static/opengraph.png',
  },
};
